<div class="box">
    <div class="myForm">
      <div class="card">
        <h4 class="card-header">Import Zoho Links using Excel Template</h4>
        <div class="card-body scroll">
          <form #zohoForm="ngForm">
            <p>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>Client</mat-label>
                <mat-select name="client" placeholder="Client" [(ngModel)]="zoho.client" required>
                  <mat-option *ngFor="let item of clients" [value]="item.id">{{item.dname}}</mat-option>
                </mat-select>
                <mat-error>*Client is required</mat-error>
              </mat-form-field>
            </p>
            <p>
              <button color="primary" class="button" type="button" mat-raised-button (click)="fileInput.click()" required>
                <mat-icon>attachment</mat-icon>
                Excel File*
              </button>
              <input hidden (change)="onFileSelected($event)" #fileInput name="xl" type="file" accept=".xls, .xlsx"
                [(ngModel)]="zoho.xl" #xl="ngModel" required />
                <br>
                <span>
                  <mat-hint><b>{{ zoho.xl?.name ? zoho.xl?.name : "&nbsp;" }}
                    <button color="primary" class="remove"
                        *ngIf="zoho.xl?.name" mat-button (click)="remove_xl()">
                        <mat-icon>delete_forever</mat-icon>
                      </button>
                    </b></mat-hint>
                </span>
            </p>
            <p>
              <mat-form-field appearance="outline" color="primary">
                <mat-label>Sub Sheet Name</mat-label>
                <mat-select name="sheetName" placeholder="Please upload Excel" (selectionChange)="sheetName()" [(ngModel)]="zoho.sheetName" required>
                  <mat-option *ngFor="let item of sheetNames" [value]="item">{{item}}</mat-option>
                </mat-select>
                <mat-error>*Sub Sheet Name is required</mat-error>
              </mat-form-field>
            </p>
            <p>
              <button color="primary" class="button btn-spc" [disabled]="!zohoForm.valid || buttonClicked"
                (click)="upload(false)" mat-raised-button>
                {{ buttonClicked && !status ? "Verifying" : "Verify" }}
                <span>
                  <mat-icon *ngIf="buttonClicked && !status">
                    <mat-spinner diameter="25"></mat-spinner>
                  </mat-icon>
                </span>
              </button>
            </p>
            <p>
              <button color="primary" class="button float-left" [disabled]="!success || resp == null" (click)="response( true )" mat-raised-button> View
                Log </button>
              <button color="primary" class="button float-right" [disabled]="!zohoForm.valid || buttonClicked"
                (click)="upload(true)" type="submit" mat-raised-button>
                {{ buttonClicked && status ? "Uploading" : "Upload" }}
                <span>
                  <mat-icon *ngIf="buttonClicked && status">
                    <mat-spinner diameter="25"></mat-spinner>
                  </mat-icon>
                </span>
              </button>
            </p>
            </form>
        </div>
      </div>
    </div>
  </div>
  
  